export default __webpack_public_path__ + "static/media/bagaimana-kontrak-bottomry-dijalankan.166fa1e2.png";